module.exports = __webpack_public_path__ + "static/media/an-qr.327c075b.jpg";